import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { logout } from '@/shared/auth/auth.reducer';
import { useSessionUserTopicSubscription } from '@/shared/hooks/useSessionUserTopicSubscription';
import { useAppDispatch, useAppSelector } from '@/store';
/**
 * Listens for supervisor force-logout events on `/topic/session.user.{username}` and ends the local session.
 */
export function SessionEventsProvider({ children }) {
    const dispatch = useAppDispatch();
    const session = useAppSelector((state) => state.auth.session);
    const username = session?.username?.trim() ?? '';
    const onForceLogout = useCallback((detail) => {
        void (async () => {
            try {
                await dispatch(logout()).unwrap();
            }
            catch {
                /* still redirect — local tokens should be cleared */
            }
            const params = new URLSearchParams({ forcedLogout: 'true' });
            const by = detail.forcedBy?.trim();
            if (by)
                params.set('forcedBy', by);
            window.location.assign(`/login?${params.toString()}`);
        })();
    }, [dispatch]);
    useSessionUserTopicSubscription({
        username,
        enabled: Boolean(username),
        onForceLogout,
    });
    return _jsx(_Fragment, { children: children });
}
